var newLine = '\r\n';
var makeWrapper = function (wrapChar) { return function (str) { return "" + wrapChar + str + wrapChar; }; };
var identityMapping = function (arr, initialMapping) {
    return arr.reduce(function (acc, k) {
        acc[k] = k;
        return acc;
    }, initialMapping);
};
var extractHeaderFromData = function (datas) {
    return datas.reduce(function (acc, v) { return Array.isArray(v) ?
        acc :
        identityMapping(Object.keys(v), acc); }, {});
};
var extractHeaderFromColumns = function (columns) {
    return columns.reduce(function (acc, v) {
        if (typeof v === 'string') {
            acc[v] = v;
        }
        else {
            acc[v.id] = (typeof v.displayName !== 'undefined') ? v.displayName : v.id;
        }
        return acc;
    }, {});
};
export default function csv(columns, datas, separator, noHeader, wrapColumnChar) {
    if (separator === void 0) { separator = ','; }
    if (noHeader === void 0) { noHeader = false; }
    if (wrapColumnChar === void 0) { wrapColumnChar = ''; }
    var wrap = makeWrapper(wrapColumnChar);
    var header = columns
        ? extractHeaderFromColumns(columns)
        : extractHeaderFromData(datas);
    var content = [];
    if (!noHeader) {
        var headerNames = Object.values(header);
        if (headerNames.length > 0) {
            content.push(headerNames.map(wrap).join(separator));
        }
    }
    if (Array.isArray(datas)) {
        var columnOrder_1 = Object.keys(header);
        datas
            .map(function (v) {
            return Array.isArray(v)
                ? v
                : columnOrder_1.map(function (k) {
                    return typeof v[k] !== 'undefined'
                        ? v[k]
                        : '';
                });
        })
            .forEach(function (v) {
            content.push(v.map(wrap).join(separator));
        });
    }
    return content.join(newLine);
}
//# sourceMappingURL=csv.js.map